const isAppleMobile = (userAgent = navigator.userAgent) => {
  return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
};

export default isAppleMobile;
